import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/panel/contentbrowser',
  }, {
    path: '/login',
    name: 'login',
    component: () => import('@/views/pages/Login'),
  }, {
    path: '/forgotpassword',
    name: 'forgotpassword',
    component: () => import('@/views/pages/ForgotPassword'),
  }, {
    path: '/panel',
    component: () => import('@/views/panel/Layout'),
    children: [
      {
        path: 'users',
        name: 'users',
        component: () => import('@/views/panel/users/Grid'),
      },
      {
        path: 'texts',
        name: 'texts',
        component: () => import('@/views/panel/texts/Index'),
      },
      {
        path: 'texts/edit/:id',
        name: 'edit_texts',
        component: () => import('@/views/panel/texts/Index'),
      },
      {
        path: 'contentsheets',
        name: 'contentsheets',
        component: () => import('@/views/panel/contentsheets/Index'),
      },
      {
        path: 'contentsheets/edit/:id',
        name: 'edit_contentsheets',
        component: () => import('@/views/panel/contentsheets/Index'),
      },
      {
        path: 'geoplanos',
        name: 'geoplanos',
        component: () => import('@/views/panel/geoplanos/Index'),
      },
      {
        path: 'geoplanos/edit/:id',
        name: 'edit_geoplanos',
        component: () => import('@/views/panel/geoplanos/Index'),
      },
      {
        path: 'charts',
        name: 'charts',
        component: () => import('@/views/panel/charts/Index'),
      },
      {
        path: 'charts/edit/:id',
        name: 'edit_charts',
        component: () => import('@/views/panel/charts/Index'),
      },
      {
        path: 'statementsimple',
        name: 'statementsimple',
        component: () => import('@/views/panel/statements/IndexSimples'),
      },
      {
        path: 'statementsimple/edit/:id',
        name: 'edit_statementsimple',
        component: () => import('@/views/panel/statements/IndexSimples'),
      },
      {
        path: 'statementformula',
        name: 'statementformula',
        component: () => import('@/views/panel/statements/IndexFormula'),
      },
      {
        path: 'statementformula/edit/:id',
        name: 'edit_statementformula',
        component: () => import('@/views/panel/statements/IndexFormula'),
      },
      {
        path: 'statementmultiple',
        name: 'statementmultiple',
        component: () => import('@/views/panel/statements/IndexMultiple'),
      },
      {
        path: 'statementmultiple/edit/:id',
        name: 'edit_statementmultiple',
        component: () => import('@/views/panel/statements/IndexMultiple'),
      },
      {
        path: 'templates',
        name: 'templates',
        component: () => import('@/views/panel/templates/Index'),
      },
      {
        path: 'templates/edit/:id',
        name: 'edit_templates',
        component: () => import('@/views/panel/templates/Index'),
      },
      {
        path: 'formulas',
        name: 'formulas',
        component: () => import('@/views/panel/formulas/Index'),
      },
      {
        path: 'formulas/edit/:id',
        name: 'edit_formulas',
        component: () => import('@/views/panel/formulas/Index'),
      },
      {
        path: 'unitmath',
        name: 'unitmath',
        component: () => import('@/views/panel/units/Index'),
      },
      {
        path: 'unitmath/edit/:id',
        name: 'edit_unitmath',
        component: () => import('@/views/panel/units/Index'),
      },
      {
        path: 'tags',
        name: 'tags',
        component: () => import('@/views/panel/tags/Tags'),
      },
      {
        path: 'images',
        name: 'images',
        component: () => import('@/views/panel/images/Index'),
      },
      {
        path: 'images/edit/:id',
        name: 'edit_images',
        component: () => import('@/views/panel/images/Index'),
      },
      {
        path: 'audios',
        name: 'audios',
        component: () => import('@/views/panel/audios/Index'),
      },
      {
        path: 'audios/edit/:id',
        name: 'edit_audios',
        component: () => import('@/views/panel/audios/Index'),
      },
      {
        path: 'writteninstructions',
        name: 'writteninstructions',
        component: () => import('@/views/panel/writteninstructions/Index'),
      },
      {
        path: 'writteninstructions/edit/:id',
        name: 'edit_writteninstructions',
        component: () => import('@/views/panel/writteninstructions/Index'),
      },
      {
        path: 'writtenorals',
        name: 'writtenorals',
        component: () => import('@/views/panel/writtenorals/Index'),
      },
      {
        path: 'writtenorals/edit/:id',
        name: 'edit_writtenorals',
        component: () => import('@/views/panel/writtenorals/Index'),
      },
      {
        path: 'contentbrowser',
        name: 'contentbrowser',
        component: () => import('@/views/panel/contentbrowser/Index'),
      },
      {
        path: 'workshop/:id/exercises',
        name: 'workshopexercises',
        component: () => import('@/views/panel/workshopexercises/Index'),
      },
      {
        path: 'concepts',
        name: 'concepts',
        component: () => import('@/views/panel/concepts/Index'),
      },
      {
        path: 'concepts/edit/:id',
        name: 'edit_concepts',
        component: () => import('@/views/panel/concepts/Index'),
      },
    ],
  },
  { path: '*', component: () => import('@/views/pages/404') },
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const publicPages = ['/login', '/forgotpassword'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('token');

  if (authRequired && !loggedIn) {
    return next('/login');
  }

  return next();
});

export default router;
